export const PageState = {
    Preload: 'State.Preload',
    PreloadComplete: 'State.PreloadComplete',
    EnterStart: 'State.EnterStart',
    EnterComplete: 'State.EnterComplete',
    LeaveStart: 'State.LeaveStart',
    LeaveComplete: 'State.LeaveComplete',
};
